/**
 * @generated SignedSource<<e677d2778e89c15968b8995d22e9d4b5>>
 * @relayHash a749bfc06fa12153bb0f8e9c8d532a51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 19f967728a7a431757ab5568f3a995df2bf041fb1b33fb4b2e1162913a3e85a7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneysPageQuery } from './JourneysPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneysPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "19f967728a7a431757ab5568f3a995df2bf041fb1b33fb4b2e1162913a3e85a7",
    "metadata": {},
    "name": "JourneysPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
